import { type FC } from 'react';
import classNames from 'classnames';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { SeoLink } from 'dibs-seo/exports/SeoLink';
import { NO_CONTENT_LINK } from 'dibs-elements/exports/SeoLink';

import { type DesignSeriesCollectionItem_design$data } from './__generated__/DesignSeriesCollectionItem_design.graphql';

import styles from './DesignSeriesCollectionItem.scss';

type Props = {
    design: DesignSeriesCollectionItem_design$data;
    size: 'small' | 'large';
    onClick?: () => void;
};

const DesignSeriesCollectionItemComponent: FC<Props> = props => {
    const { design, size, onClick = () => {} } = props;

    if (!design.displayName || !design.imageUrl) {
        return null;
    }

    return (
        <SeoLink
            className={classNames(styles.linkContainer, {
                [styles.large]: size === 'large',
                [styles.small]: size === 'small',
            })}
            linkData={design.linkData}
            dataTn={`design-series-link-${design.displayName}`}
            onClick={onClick}
            variant={NO_CONTENT_LINK}
        >
            <div className={styles.imageContainer}>
                <img className={styles.image} src={design.imageUrl} alt={design.displayName} />
            </div>
            <div className={styles.title}>{design.displayName}</div>
        </SeoLink>
    );
};

export const DesignSeriesCollectionItem = createFragmentContainer(
    DesignSeriesCollectionItemComponent,
    {
        design: graphql`
            fragment DesignSeriesCollectionItem_design on IconicDesignSeriesItem {
                displayName
                linkData {
                    ...SeoLink_linkData
                }
                imageUrl
            }
        `,
    }
);
